<div class="callback-page">
  @if (isLoading()) {
    <div class="callback-page__loading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'app.patrol.discord.cockpit.connect.callbackLinking' | translate }}</p>
    </div>
  } @else {
    @if (errorKey(); as key) {
      <div class="callback-page__error">
        <h1 class="callback-page__title">
          {{ 'app.patrol.discord.cockpit.connect.callbackErrorTitle' | translate }}
        </h1>
        <p class="callback-page__text">{{ key | translate }}</p>
        <app-cta-button size="small" routerLink="/discord">
          <span cta-label>{{
            'app.patrol.discord.cockpit.connect.callbackBack' | translate
          }}</span>
        </app-cta-button>
      </div>
    }
  }
</div>
